export default __webpack_public_path__ + "static/media/FlyingFrog17.71247b1c.png";